var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#979AAF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.772 6.26h12.456c.234 0 .424-.194.424-.434V2.783c0-.24-.19-.435-.424-.435H2.772c-.234 0-.424.194-.424.435v3.043c0 .24.19.435.424.435zm.425-3.043h11.606v2.174H3.197V3.217zM2.785 14.087h5.387c.241 0 .437-.197.437-.44V7.484c0-.243-.196-.44-.437-.44H2.785c-.242 0-.437.197-.437.44v6.163c0 .243.195.44.437.44zm.437-6.163h4.513v5.283H3.222V7.924zM15.215 7.043H9.828c-.241 0-.437.198-.437.44v6.164c0 .243.196.44.437.44h5.387c.242 0 .437-.197.437-.44V7.484c0-.243-.195-.44-.437-.44zm-.437 6.164h-4.513V7.924h4.513v5.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.23V.422C18 .189 17.805 0 17.564 0H.436C.195 0 0 .19 0 .423v14.806c0 .234.195.423.436.423h17.128c.241 0 .436-.19.436-.423zm-.871-.424H.871V.846h16.258v13.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.620451fb2abf8d8a9381d07f6e512ed0.svg";
export { ForwardRef as ReactComponent };